import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus } from "lucide-react";
import { PreferencesData } from "../../utils/guestSchema";
import TagList from "./TagList";

interface PreferencesComponentProps {
  preferences: PreferencesData;
  setPreferences: (preferences: PreferencesData) => void;
}

const PreferencesComponent: React.FC<PreferencesComponentProps> = ({
  preferences,
  setPreferences,
}) => {
  const [newFoodItem, setNewFoodItem] = useState("");
  const [newNoteItem, setNewNoteItem] = useState("");

  const handleAccommodationChange = (value: string) => {
    setPreferences({
      ...preferences,
      accommodation: value,
    });
  };

  const addFoodItem = () => {
    if (newFoodItem.trim()) {
      const currentFood = preferences.food || [];
      setPreferences({
        ...preferences,
        food: [...currentFood, newFoodItem.trim()],
      });
      setNewFoodItem("");
    }
  };

  const removeFoodItem = (index: number) => {
    const currentFood = preferences.food || [];
    setPreferences({
      ...preferences,
      food: currentFood.filter((_, i) => i !== index),
    });
  };

  const addNoteItem = () => {
    if (newNoteItem.trim()) {
      const currentNotes = preferences.notes || [];
      setPreferences({
        ...preferences,
        notes: [...currentNotes, newNoteItem.trim()],
      });
      setNewNoteItem("");
    }
  };

  const removeNoteItem = (index: number) => {
    const currentNotes = preferences.notes || [];
    setPreferences({
      ...preferences,
      notes: currentNotes.filter((_, i) => i !== index),
    });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="accommodation">Accommodation</Label>
        <Input
          id="accommodation"
          value={preferences.accommodation || ""}
          onChange={(e) => handleAccommodationChange(e.target.value)}
          placeholder="Enter accommodation preference"
        />
      </div>

      <div className="space-y-2">
        <Label>Food Preferences</Label>
        <div className="flex gap-2">
          <Input
            value={newFoodItem}
            onChange={(e) => setNewFoodItem(e.target.value)}
            placeholder="Add food preference"
          />
          <Button
            type="button"
            variant="new_outline"
            size="icon_sm"
            onClick={addFoodItem}
            aria-label="Add food preference"
          >
            <Plus />
          </Button>
        </div>
        <TagList items={preferences.food || []} onRemove={removeFoodItem} />
      </div>

      <div className="space-y-2">
        <Label>Notes</Label>
        <div className="flex gap-2">
          <Input
            value={newNoteItem}
            onChange={(e) => setNewNoteItem(e.target.value)}
            placeholder="Add note"
          />
          <Button
            type="button"
            variant="new_outline"
            size="icon_sm"
            onClick={addNoteItem}
            aria-label="Add note"
          >
            <Plus />
          </Button>
        </div>
        <TagList items={preferences.notes || []} onRemove={removeNoteItem} />
      </div>
    </div>
  );
};

export default PreferencesComponent;
